module.exports = __webpack_public_path__ + "static/media/chelsea_profile.751b49cb.jpg";